import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SpecialModule } from 'lib/modules/special.module';
import { ImageZoomModule } from '../../../../../components/image-zoom/image-zoom.module';
import { CmsPartialComponentClass } from 'lib/components/cms/cms-partial-component.class';
import { CategoryService } from 'lib/services/category/category.service';
import { RouterService } from 'lib/services/router.service';
import { WebpService } from 'lib/services/webp.service';
@Component({
    selector: 'cms-partial-category-top-multiple-columns',
    templateUrl: './multiple-columns.component.html',
    styleUrls: ['./multiple-columns.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [CommonModule, RouterModule, SpecialModule, ImageZoomModule],
})
export class MultipleColumnsComponent extends CmsPartialComponentClass {
    @Input() multipleColumnsRow: any;
    getWebpImg: (src: string) => string;

    constructor(
        @Inject('environment') environment: any,
        routerService: RouterService,
        webpService: WebpService,
        location: Location,
        categoryService: CategoryService
    ) {
        super({
            dependencies: {
                environment,
                routerService,
                location,
                categoryService,
                webpService,
            },
        });
        this.getWebpImg = (src: string) => webpService.getWebpImg(src);
    }
}
